const SocialPrefixes = {
    FACEBOOK: 'https://facebook.com/',
    INSTAGRAM: 'https://instagram.com/',
    TIKTOK: 'https://www.tiktok.com/@',
}

Object.freeze(SocialPrefixes)

export default SocialPrefixes
